<article class="reports-sub-domain-container">
  <div class="reports-sub-domain">
    <app-programs-reports-side-menu></app-programs-reports-side-menu>
    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
